import {
  SummaryHeader,
  SummaryHeaderColumn,
  SummaryHeaderItem,
} from '@trueprodigy/components';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import ImmutablePropTypes from 'react-immutable-proptypes';
import styled from 'styled-components';

import { eventFormListSelector } from '@modules/events/selectors/eventform';

import { getEventForm } from './EventDetailFormHelper';

const EventSummary = ({ eventFormList, formID }) => (
  <EventSummary.Main>
    <SummaryHeader hasOutline={false}>
      <SummaryHeaderColumn item lg={6} md={6} sm={12}>
        <SummaryHeaderItem
          label="Event Form"
          value={getEventForm(eventFormList, formID)?.formName}
        />
        <SummaryHeaderItem
          label="Description"
          value={getEventForm(eventFormList, formID)?.description}
        />
      </SummaryHeaderColumn>
      <SummaryHeaderColumn item lg={6} md={6} sm={12}>
        <SummaryHeaderItem
          label="Data Object"
          value={getEventForm(eventFormList, formID)?.dataObject}
        />
        <SummaryHeaderItem
          label="Event Group"
          value={getEventForm(eventFormList, formID)?.formGroup}
        />
      </SummaryHeaderColumn>
    </SummaryHeader>
  </EventSummary.Main>
);

EventSummary.propTypes = {
  formID: PropTypes.any,
  eventFormList: ImmutablePropTypes.map,
};

EventSummary.Main = styled.div`
  display: flex;
  flex-flow: row wrap;
  margin-bottom: 15px;
  box-shadow: 0 0.5px 1.5px 0 rgba(0, 0, 0, 0.16);
`;

const mapStateToProps = state => ({
  eventFormList: eventFormListSelector(state),
});

const enhance = compose(
  connect(
    mapStateToProps,
    null,
  ),
);

export default enhance(EventSummary);
